module.exports = __webpack_public_path__ + "img/1. MICROLINES CUT - START KIT.jpg";